import { SessionHelper } from "app/helpers/sessionHelper";
import { ExchangeBetType } from "app/types/reportType";
import React from "react";
import { connect } from "react-redux";
import "../StatementExchange.scss";
import StatementExchangeFooter from "../StatementExchangeFooter/StatementExchangeFooter";
import StatementExchangeBetsContentFooter from "./components/StatementExchangeBetsContentFooter/StatementExchangeBetsContentFooter";
import StatementExchangeBetsGrid from "./components/StatementExchangeBetsGrid/StatementExchangeBetsGrid";

const StatementExchangeBets: React.FC<{
  statementList: ExchangeBetType[];
  totalPayout: number;
  totalItems: number;
  backSubtotal: number;
  laySubtotal: number;
  marketSubtotal: number;
  commissionRate: number;
  commissionAmount: number;
  finalScores: string;
}> = ({
  statementList,
  backSubtotal,
  laySubtotal,
  commissionAmount,
  marketSubtotal,
  commissionRate,
  totalPayout,
  finalScores,
}) => {
  const uiViewMode = SessionHelper.isAsianRouteAndSessionView()
    ? "asian"
    : "euro";
  return (
    <div className={`statement-exchange--${uiViewMode}`}>
      <StatementExchangeBetsGrid
        statementList={statementList}
        finalScores={finalScores}
      />
      <StatementExchangeBetsContentFooter
        backSubtotal={backSubtotal}
        laySubtotal={laySubtotal}
        commissionAmount={commissionAmount}
        marketSubtotal={marketSubtotal}
        commissionRate={commissionRate}
        totalPayout={totalPayout}
      />
      <StatementExchangeFooter totalPayout={totalPayout} />
    </div>
  );
};

const mapStateToProps = (state: {
  statementListModel: {
    totalPayout: number;
    statementList: ExchangeBetType[];
    totalItems: number;
    backSubtotal: number;
    laySubtotal: number;
    marketSubtotal: number;
    commissionRate: number;
    commissionAmount: number;
    finalScores: string;
  };
}) => ({
  totalPayout: state.statementListModel.totalPayout,
  statementList: state.statementListModel.statementList,
  totalItems: state.statementListModel.totalItems,
  backSubtotal: state.statementListModel.backSubtotal,
  laySubtotal: state.statementListModel.laySubtotal,
  marketSubtotal: state.statementListModel.marketSubtotal,
  commissionRate: state.statementListModel.commissionRate,
  commissionAmount: state.statementListModel.commissionAmount,
  finalScores: state.statementListModel.finalScores,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatementExchangeBets) as any;
